export default __webpack_public_path__ + "static/media/about1.02a3d8dd.jpg";